exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg[data-v-66fcd571] {\n  width: 20px;\n  height: 15px;\n  display: inline-block;\n}\nsvg circle[data-v-66fcd571] {\n    fill: #fff;\n}\n", ""]);

// exports
